<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>

        <!-- Page header -->
        <v-flex xs12>
          <div class="modern-page-header">
            <div class="modern-page-header__left">
              <div class="modern-page-header__icon-wrap">
                <v-icon class="modern-page-header__icon">credit_card</v-icon>
              </div>
              <div>
                <h3 class="modern-page-header__title">Payments</h3>
                <p class="modern-page-header__sub">School subscription and payment status</p>
              </div>
            </div>
          </div>
        </v-flex>

        <v-flex lg12>
          <v-card class="modern-table-card">
            <div class="modern-table-toolbar">
              <div class="modern-search-wrap">
                <v-icon class="modern-search-icon">search</v-icon>
                <input
                  v-model="search"
                  class="modern-search-input"
                  placeholder="Search payments..."
                />
              </div>
              <v-btn icon flat class="modern-toolbar-btn" title="Filter">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </div>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                item-key="name"
                class="modern-data-table"
              >
                <template slot="items" slot-scope="props">
                  <td class="table-cell-mono">{{ props.item.company_no }}</td>
                  <td class="table-cell-primary">{{ props.item.company_name }}</td>
                  <td class="table-cell-secondary">{{ props.item.last_payment_date }}</td>
                  <td class="table-cell-secondary">{{ props.item.exp_date }}</td>
                  <td>
                    <div class="remaining-badge" :class="getRemainingClass(props.item.remaining)">
                      {{ props.item.remaining }}
                    </div>
                  </td>
                  <td>
                    <div class="status-pill" :class="props.item.status === 'Active' ? 'status-pill--active' : 'status-pill--inactive'">
                      <span class="status-pill__dot"></span>
                      {{ props.item.status }}
                    </div>
                  </td>
                  <td>
                    <v-btn
                      small
                      depressed
                      color="primary"
                      class="table-action-btn"
                      @click="handleMoreInfo(props.item)"
                    >
                      <v-icon left x-small>receipt</v-icon>Check
                    </v-btn>
                  </td>
                </template>
                <template slot="no-data">
                  <div class="modern-empty-state">
                    <v-icon class="modern-empty-state__icon">credit_card</v-icon>
                    <p class="modern-empty-state__text">No payment records found</p>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import APIPayment from "@/mixins/APIPayment";
export default {
  mixins: [APIPayment],
  data() {
    return {
      search: "",
      complex: {
        selected: [],
        headers: [
          { text: "Identifier", value: "company_no" },
          { text: "Name", value: "company_name" },
          { text: "Last Payment", value: "last_payment_date" },
          { text: "Expires", value: "exp_date" },
          { text: "Remaining", value: "remaining" },
          { text: "Status", value: "status" },
          { text: "Action", value: "", sortable: false, align: "center" }
        ],
        items: []
      }
    };
  },
  created() {
    this.handleGet();
  },
  methods: {
    getRemainingClass(remaining) {
      const days = parseInt(remaining);
      if (days <= 7) return "remaining-badge--critical";
      if (days <= 30) return "remaining-badge--warning";
      return "remaining-badge--ok";
    },
    handleGet: async function() {
      try {
        let res = await this.getCompanies();
        this.complex.items = res.map(obj => {
          const moment = require("moment");
          obj.last_payment_date = obj.last_payment_date
            ? obj.last_payment_date.split("T")[0]
            : "N/A";
          obj.exp_date = obj.exp_date ? obj.exp_date.split("T")[0] : "N/A";
          let now = moment();
          let days = moment(obj.exp_date).diff(moment(now.format().split("T")[0]), "days");
          obj.remaining = (days >= 0 ? days : 0) + " days left";
          obj.status = obj.status === 1 ? "Active" : "Reject";
          return obj;
        });
      } catch (error) {
        this.$toast.error("Cannot get details!", "Error", { position: "topCenter" });
      }
    },
    handleMoreInfo: function(row) {
      this.$router.push({ name: "Payment Check", params: { object: row, id: row._id } });
    }
  }
};
</script>

<style scoped lang="css">
.modern-page-header {
  display: flex;
  align-items: center;
  padding: 8px 0 20px;
}

.modern-page-header__left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-page-header__icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #43A047, #2e7d32);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modern-page-header__icon {
  color: #ffffff !important;
  font-size: 22px !important;
}

.modern-page-header__title {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.3px;
}

.modern-page-header__sub {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 13px;
  color: #64748b;
  margin: 2px 0 0;
}

.modern-table-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.modern-table-toolbar {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  gap: 8px;
}

.modern-search-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  gap: 10px;
  transition: border-color 0.2s ease;
}

.modern-search-wrap:focus-within {
  border-color: #1565C0;
  background: #ffffff;
}

.modern-search-icon {
  color: #94a3b8 !important;
  font-size: 18px !important;
}

.modern-search-input {
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 14px;
  color: #334155;
  width: 100%;
}

.modern-search-input::placeholder {
  color: #94a3b8;
}

.modern-toolbar-btn {
  color: #64748b !important;
}

.table-cell-mono {
  font-family: 'SF Mono', 'Roboto Mono', monospace;
  font-size: 13px !important;
  color: #475569 !important;
}

.table-cell-primary {
  font-weight: 600 !important;
  color: #1e293b !important;
}

.table-cell-secondary {
  color: #64748b !important;
  font-size: 14px !important;
}

.remaining-badge {
  display: inline-flex;
  padding: 3px 10px;
  border-radius: 20px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 600;
}

.remaining-badge--ok {
  background: rgba(67, 160, 71, 0.1);
  color: #2e7d32;
}

.remaining-badge--warning {
  background: rgba(251, 140, 0, 0.1);
  color: #e65100;
}

.remaining-badge--critical {
  background: rgba(244, 67, 54, 0.1);
  color: #c62828;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 600;
}

.status-pill--active {
  background: rgba(67, 160, 71, 0.1);
  color: #2e7d32;
}

.status-pill--inactive {
  background: rgba(100, 116, 139, 0.1);
  color: #475569;
}

.status-pill__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-pill--active .status-pill__dot { background: #43a047; }
.status-pill--inactive .status-pill__dot { background: #94a3b8; }

.table-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 500 !important;
  text-transform: none !important;
  border-radius: 7px !important;
  height: 30px !important;
  min-width: unset !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 6px rgba(21, 101, 192, 0.25) !important;
}

.modern-empty-state {
  padding: 60px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.modern-empty-state__icon {
  font-size: 48px !important;
  color: #cbd5e1 !important;
}

.modern-empty-state__text {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 15px;
  color: #94a3b8;
  margin: 0;
}
</style>
